import React, { useState, useEffect } from 'react'

export default function GameNotes({notes, onLoadNotes, onCreateNote, onEditNote, onRemoveNote}) {
  const [canEdit, setCanEdit] = useState([])
  const [newNote, setNewNote] = useState('')
  const [note, setNote] = useState('')

  useEffect(() => {
    onLoadNotes()
  }, [])

  const createNote = (e) => {
    e.preventDefault()
    e.target.blur()
    if (newNote.length) onCreateNote(newNote)
    setNewNote('')
  }

  const editNote = (e, noteId) => {
    e.preventDefault()
    e.target.blur()
    if (note.length) onEditNote({id: noteId, text: note})
    setEditAbility(noteId, false)
    setNote('')
  }

  const setEditAbility = (noteId, allow) => {
    if (allow)
      setCanEdit(canEdit.concat(noteId))
    else 
      setCanEdit(canEdit.filter(function(item) { return item !== noteId }))
  }

  if (!notes) return <div className='animated-spinner'></div>

  return <div>
    <form>
      <div className='form-group'>
        <input 
          placeholder='Notes' 
          className='form-control' 
          type='text'
          value={newNote}
          onChange={(e) => setNewNote(e.target.value)} 
        />
      </div>
      <div className='form-group text-center'>
        <input type='submit' name='commit' value='Submit' className='btn btn-success' onClick={createNote}/>
      </div>
    </form>

    <table className='table table-striped text-center table-transference'>
      <thead>
        <tr>
          <th>Note</th>
          <th>User</th>
          <th>Time</th>
        </tr>
      </thead>
      <tbody>
        {
          notes.map(note => {
            return <tr key={note.id}>
              <td>
                { !canEdit.includes(note.id) &&
                  <div>
                    <span 
                      className='fa fa-pencil note-edit-icon' 
                      onClick={() => setEditAbility(note.id, true)}>
                    </span>&nbsp;
                    <span>{note.text}</span>
                  </div>
                }
                { canEdit.includes(note.id) &&
                  <form>
                    <div className='inline'>
                      <input 
                        className='form-control' 
                        defaultValue={note.text} 
                        autoFocus
                        type='text'
                        onBlur={() => setTimeout(() => { setEditAbility(note.id, false) }, 200)}
                        onChange={(e) => setNote(e.target.value)}
                      />
                    </div>
                    <input 
                      type='submit' 
                      name='commit' 
                      value='OK' 
                      className='btn btn-info' 
                      onClick={(e) => editNote(e, note.id)} 
                    />
                  </form>
                }
              </td>
              <td className='td-transference'>{note.user}</td>
              <td className='td-transference'>
                {note.date}
                <a className='btn btn-danger' onClick={(e) => onRemoveNote(note.id)}>
                  <i className='fa fa-trash-o'></i>
                </a>
              </td>
            </tr>
          })
        }
      </tbody>
    </table>
  </div>
}
